// const common_api = process.env.REACT_APP_NODE_SERVICE_BASE_URL;

// export const formHeading = "Work Type";

// export const uriBasePath = "work-types";
// export const newRecord = `/work-types/new`;
// export const submitApi = `${common_api}/work-type/api/work-types`;

// export const listApi = `${common_api}/work-type/api/work-types/`;

// export const formFields = [
//   {
//     fieldName: "name",
//     displayName: "Name",
//     sequence: 0,
//     required: true,
//     tag: "input",
//     inputType: "text",
//   },
//   {
//     fieldName: "unit_id",
//     displayName: "Unit",
//     sequence: 0,
//     tag: "select",
//     data: {
//       tableName: "common_master",
//       columnName: "unit",
//     },
//   },
//   {
//     fieldName: "active_from",
//     displayName: "Active From",
//     sequence: 1,
//     required: true,
//     tag: "input",
//     inputType: "datetime-local",
//   },
//   {
//     fieldName: "active_to",
//     displayName: "Active To",
//     sequence: 1,
//     required: true,
//     tag: "input",
//     inputType: "datetime-local",
//   },
//   {
//     fieldName: "remarks",
//     displayName: "Remarks",
//     sequence: 2,
//     tag: "input",
//     inputType: "text",
//   },
//   {
//     fieldName: "cgst",
//     displayName: "CGST %",
//     sequence: 3,
//     required: true,
//     tag: "input",
//     inputType: "number",
//   },
//   {
//     fieldName: "sgst",
//     displayName: "SGST %",
//     sequence: 3,
//     required: true,
//     tag: "input",
//     inputType: "number",
//   },
//   {
//     fieldName: "igst",
//     displayName: "IGST %",
//     sequence: 3,
//     tag: "input",
//     required: true,
//     inputType: "number",
//   },
//   {
//     fieldName: "hsn_code",
//     displayName: "HSN code",
//     sequence: 4,
//     tag: "input",
//     inputType: "text",
//   },
//   {
//     fieldName: "hsn_desc",
//     displayName: "HSN description",
//     sequence: 4,
//     tag: "input",
//     inputType: "text",
//   },
//   {
//     fieldName: "rev_type",
//     displayName: "Revenue type",
//     sequence: 5,
//     tag: "select",
//     data: {
//       tableName: "common_master",
//       columnName: "rev_type",
//     },
//   },
//   {
//     fieldName: "component_for",
//     displayName: "Component for",
//     sequence: 5,
//     tag: "select",
//     data: {
//       tableName: "common_master",
//       columnName: "component_for",
//     },
//   },
//   {
//     fieldName: "invoice_for",
//     displayName: "Invoice for",
//     sequence: 5,
//     required: true,
//     tag: "select",
//     data: {
//       tableName: "common_master",
//       columnName: "invoice_for",
//     },
//     isMulti: true,
//     send_value: true,
//   },
//   {
//     fieldName: "hrs_applicable",
//     displayName: "Hours applicable",
//     sequence: 6,
//     required: true,
//     tag: "input",
//     inputType: "checkbox",
//   },
//   {
//     fieldName: "active",
//     displayName: "Active",
//     sequence: 6,
//     required: true,
//     tag: "input",
//     inputType: "checkbox",
//   },
// ];

// // New export for table column configuration
// export const tableFields = [
//   {
//     fieldName: "id",
//     displayName: "ID",
//   },
//   { fieldName: "name", displayName: "Name" },
//   {
//     fieldName: "unit_id",
//     displayName: "Unit",
//     render: (value, row) => row.unit_id || value,
//   },
//   {
//     fieldName: "active_from",
//     displayName: "Active From",
//     render: (dateString) =>
//       dateString ? new Date(dateString).toLocaleDateString() : "",
//   },
//   {
//     fieldName: "active_to",
//     displayName: "Active To",
//     render: (dateString) =>
//       dateString ? new Date(dateString).toLocaleDateString() : "",
//   },
//   {
//     fieldName: "cgst",
//     displayName: "CGST (%)",
//     render: (value) => Number(value),
//   },
//   {
//     fieldName: "sgst",
//     displayName: "SGST (%)",
//     render: (value) => Number(value),
//   },
//   {
//     fieldName: "igst",
//     displayName: "IGST (%)",
//     render: (value) => Number(value),
//   },
//   {
//     fieldName: "active",
//     displayName: "Active",
//     render: (value) => (value ? "Yes" : "No"),
//   },
// ];

// export const validationRules = [
//   {
//     fields: ["active_from", "active_to"],
//     validator: (formData) => {
//       const activeFrom = formData.active_from;
//       const activeTo = formData.active_to;

//       if (activeFrom && activeTo) {
//         const dateFrom = new Date(activeFrom);
//         const dateTo = new Date(activeTo);

//         if (dateFrom > dateTo) {
//           return {
//             message: "Active From date cannot be after Active To date.",
//             fields: ["active_from", "active_to"],
//           };
//         }
//       }

//       return null;
//     },
//   },
//   {
//     fields: ["cgst", "sgst", "igst"],
//     validator: (formData) => {
//       const cgst = parseFloat(formData.cgst);
//       const sgst = parseFloat(formData.sgst);
//       const igst = parseFloat(formData.igst);

//       if (!isNaN(cgst) && (cgst < 0 || cgst > 100)) {
//         return {
//           message: "CGST value must be between 0 and 100.",
//           fields: ["cgst"],
//         };
//       }

//       if (!isNaN(sgst) && (sgst < 0 || sgst > 100)) {
//         return {
//           message: "SGST value must be between 0 and 100.",
//           fields: ["sgst"],
//         };
//       }

//       if (!isNaN(igst) && (igst < 0 || igst > 100)) {
//         return {
//           message: "IGST value must be between 0 and 100.",
//           fields: ["igst"],
//         };
//       }

//       return null;
//     },
//   },
// ];

// export const calculationRules = [
//   {
//     triggerFields: ["cgst", "sgst", "igst"],
//     calculate: (formData, changedField) => {
//       const cgst = parseFloat(formData.cgst) || 0;
//       const sgst = parseFloat(formData.sgst) || 0;
//       const igst = parseFloat(formData.igst) || 0;

//       const updatedValues = {};

//       // Determine which field to calculate based on the changed field
//       switch (changedField) {
//         case "cgst":
//           updatedValues.sgst = cgst;
//           updatedValues.igst = (cgst + cgst).toFixed(2);
//           break;
//         case "sgst":
//           updatedValues.cgst = sgst;
//           updatedValues.igst = (sgst + sgst).toFixed(2);
//           break;
//         case "igst": {
//           const halfIgst = (igst / 2).toFixed(2);
//           updatedValues.cgst = halfIgst;
//           updatedValues.sgst = halfIgst;
//           break;
//         }
//         default:
//           break;
//       }
//       return updatedValues;
//     },
//   },
// ];



const common_api = process.env.REACT_APP_NODE_SERVICE_BASE_URL;

export const formHeading = "Work Type";

// --- FIX: Added '/organization' prefix to all paths to match App.js router ---
export const uriBasePath = "organization/work-types";
export const newRecord = "/organization/work-types/new";

export const submitApi = `${common_api}/work-type/api/work-types`;

export const listApi = `${common_api}/work-type/api/work-types/`;

export const formFields = [
  {
    fieldName: "name",
    displayName: "Name",
    sequence: 0,
    required: true,
    tag: "input",
    inputType: "text",
  },
  {
    fieldName: "unit_id",
    displayName: "Unit",
    sequence: 0,
    tag: "select",
    data: {
      tableName: "common_master",
      columnName: "unit",
    },
  },
  {
    fieldName: "active_from",
    displayName: "Active From",
    sequence: 1,
    required: true,
    tag: "input",
    inputType: "datetime-local",
  },
  {
    fieldName: "active_to",
    displayName: "Active To",
    sequence: 1,
    required: true,
    tag: "input",
    inputType: "datetime-local",
  },
  {
    fieldName: "remarks",
    displayName: "Remarks",
    sequence: 2,
    tag: "input",
    inputType: "text",
  },
  {
    fieldName: "cgst",
    displayName: "CGST %",
    sequence: 3,
    required: true,
    tag: "input",
    inputType: "number",
  },
  {
    fieldName: "sgst",
    displayName: "SGST %",
    sequence: 3,
    required: true,
    tag: "input",
    inputType: "number",
  },
  {
    fieldName: "igst",
    displayName: "IGST %",
    sequence: 3,
    tag: "input",
    required: true,
    inputType: "number",
  },
  {
    fieldName: "hsn_code",
    displayName: "HSN code",
    sequence: 4,
    tag: "input",
    inputType: "text",
  },
  {
    fieldName: "hsn_desc",
    displayName: "HSN description",
    sequence: 4,
    tag: "input",
    inputType: "text",
  },
  {
    fieldName: "rev_type",
    displayName: "Revenue type",
    sequence: 5,
    tag: "select",
    data: {
      tableName: "common_master",
      columnName: "rev_type",
    },
  },
  {
    fieldName: "component_for",
    displayName: "Component for",
    sequence: 5,
    tag: "select",
    data: {
      tableName: "common_master",
      columnName: "component_for",
    },
  },
  {
    fieldName: "invoice_for",
    displayName: "Invoice for",
    sequence: 5,
    required: true,
    tag: "select",
    data: {
      tableName: "common_master",
      columnName: "invoice_for",
    },
    isMulti: true,
    send_value: true,
  },
  {
    fieldName: "hrs_applicable",
    displayName: "Hours applicable",
    sequence: 6,
    required: true,
    tag: "input",
    inputType: "checkbox",
  },
  {
    fieldName: "active",
    displayName: "Active",
    sequence: 6,
    required: true,
    tag: "input",
    inputType: "checkbox",
  },
];

// New export for table column configuration
export const tableFields = [
  {
    fieldName: "id",
    displayName: "ID",
  },
  { fieldName: "name", displayName: "Name" },
  {
    fieldName: "unit_id",
    displayName: "Unit",
    render: (value, row) => row.unit_id || value,
  },
  {
    fieldName: "active_from",
    displayName: "Active From",
    render: (dateString) =>
      dateString ? new Date(dateString).toLocaleDateString() : "",
  },
  {
    fieldName: "active_to",
    displayName: "Active To",
    render: (dateString) =>
      dateString ? new Date(dateString).toLocaleDateString() : "",
  },
  {
    fieldName: "cgst",
    displayName: "CGST (%)",
    render: (value) => Number(value),
  },
  {
    fieldName: "sgst",
    displayName: "SGST (%)",
    render: (value) => Number(value),
  },
  {
    fieldName: "igst",
    displayName: "IGST (%)",
    render: (value) => Number(value),
  },
  {
    fieldName: "active",
    displayName: "Active",
    render: (value) => (value ? "Yes" : "No"),
  },
];

export const validationRules = [
  {
    fields: ["active_from", "active_to"],
    validator: (formData) => {
      const activeFrom = formData.active_from;
      const activeTo = formData.active_to;

      if (activeFrom && activeTo) {
        const dateFrom = new Date(activeFrom);
        const dateTo = new Date(activeTo);

        if (dateFrom > dateTo) {
          return {
            message: "Active From date cannot be after Active To date.",
            fields: ["active_from", "active_to"],
          };
        }
      }

      return null;
    },
  },
  {
    fields: ["cgst", "sgst", "igst"],
    validator: (formData) => {
      const cgst = parseFloat(formData.cgst);
      const sgst = parseFloat(formData.sgst);
      const igst = parseFloat(formData.igst);

      if (!isNaN(cgst) && (cgst < 0 || cgst > 100)) {
        return {
          message: "CGST value must be between 0 and 100.",
          fields: ["cgst"],
        };
      }

      if (!isNaN(sgst) && (sgst < 0 || sgst > 100)) {
        return {
          message: "SGST value must be between 0 and 100.",
          fields: ["sgst"],
        };
      }

      if (!isNaN(igst) && (igst < 0 || igst > 100)) {
        return {
          message: "IGST value must be between 0 and 100.",
          fields: ["igst"],
        };
      }

      return null;
    },
  },
];

export const calculationRules = [
  {
    triggerFields: ["cgst", "sgst", "igst"],
    calculate: (formData, changedField) => {
      const cgst = parseFloat(formData.cgst) || 0;
      const sgst = parseFloat(formData.sgst) || 0;
      const igst = parseFloat(formData.igst) || 0;

      const updatedValues = {};

      // Determine which field to calculate based on the changed field
      switch (changedField) {
        case "cgst":
          updatedValues.sgst = cgst;
          updatedValues.igst = (cgst + cgst).toFixed(2);
          break;
        case "sgst":
          updatedValues.cgst = sgst;
          updatedValues.igst = (sgst + sgst).toFixed(2);
          break;
        case "igst": {
          const halfIgst = (igst / 2).toFixed(2);
          updatedValues.cgst = halfIgst;
          updatedValues.sgst = halfIgst;
          break;
        }
        default:
          break;
      }
      return updatedValues;
    },
  },
];